<div class="trend-bar" role="img" [attr.aria-label]="computedAriaLabel">
    <div class="trend-bar__slot" *ngFor="let value of values; trackBy: trackByIndex">
        <div class="trend-bar__box" *ngIf="value === null" aria-hidden="true"></div>
        <div class="trend-bar__band" *ngIf="value === 'noChange'" aria-hidden="true"></div>
        <div class="trend-bar__fill trend-bar__fill--better" *ngIf="value === 'better'" aria-hidden="true"></div>
        <div class="trend-bar__fill trend-bar__fill--worse" *ngIf="value === 'worse'" aria-hidden="true"></div>
    </div>
</div>
